import { useState } from 'react'

import { Widget } from '../../Widget'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, node, text } from '../Controls'

export function WidgetUsage() {
  const [props, setProps] = useState(() =>
    controls()
      .add(node('children', <div>Text inside</div>))
      .add(boolean('isSkeleton'))
      .add(text('title', 'Widget title'))
  )

  return (
    <>
      <Component {...props.getValues()} Component={Widget} name='Widget' />
      <ComponentProps name='Widget' value={props} onChange={setProps} />
    </>
  )
}
